import {JsonApiParams} from '@tisa-group/cdk';
import {UmpireSeason} from '@tisa-group/models';

export class LoadSeasons {
  static readonly type = '[Seasons] Load seasons';

  constructor(readonly params?: JsonApiParams) {}
}

export class SelectSeason {
  static readonly type = '[Seasons] Select season';

  constructor(readonly season: UmpireSeason) {}
}
